// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__2BT9u"};